export default "__VITE_ASSET__CLhRgM4X__"